import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-14" data-id="element-101" data-mp="1o3x3nprb6w3l">
      <div className="flex flex-col items-center gap-5 rounded-3xl border-2 border-amber-400 bg-amber-50 p-6 text-center md:flex-row md:p-8 md:text-left" data-id="element-102" data-mp="1o5q1cfjy25zg">
        <span className="inline-flex shrink-0 rounded-full border-2 border-blue-950 bg-white p-4" data-id="element-103" data-mp="1x421b86pag4k">
          <ShieldIcon className="h-9 w-9 text-blue-950" data-id="element-104" data-mp="19dz8gpuyp64w" />
        </span>
        <div data-id="element-105" data-mp="14fxswewqvoy6">
          <h2 className="text-lg font-black uppercase text-blue-950 md:text-xl" data-id="element-106" data-mp="14g6504l1mq8b">
            7-Day Guarantee
          </h2>
          <p className="mt-1 text-sm font-black text-blue-950" data-id="element-107" data-mp="1j5c4ltnsmigq">
            Explore the complete system with confidence.
          </p>
          <p className="mt-2 text-sm font-semibold leading-relaxed text-slate-700" data-id="element-108" data-mp="1ebr5fyagrify">
            Open the volumes, look through the decision systems, worksheets, category guides, and
            bonuses. If it is not what you expected, email{' '}
            <b className="font-black text-blue-950" data-id="element-109" data-mp="p0b7vx1bzcgh">COMPRADIGITALYAA@GMAIL.COM</b> within 7 days
            of your purchase and request your refund.
          </p>
        </div>
      </div>
    </section>;
}